/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createExistsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type ExistsResponse, type InternalErrorResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organizations/salesreps/exists
 */
export interface ExistsRequestBuilder extends BaseRequestBuilder<ExistsRequestBuilder> {
    /**
     * Checks to see if a Sales Rep exists in our Authorization provider and for this Organization. Returns true if the sales rep exists, false if not.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ExistsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ExistsRequestBuilderGetQueryParameters> | undefined) : Promise<ExistsResponse | undefined>;
    /**
     * Checks to see if a Sales Rep exists in our Authorization provider and for this Organization. Returns true if the sales rep exists, false if not.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ExistsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Checks to see if a Sales Rep exists in our Authorization provider and for this Organization. Returns true if the sales rep exists, false if not.
 */
export interface ExistsRequestBuilderGetQueryParameters {
    emailAddress?: string;
}
/**
 * Uri template for the request builder.
 */
export const ExistsRequestBuilderUriTemplate = "{+baseurl}/api/organizations/salesreps/exists?emailAddress={emailAddress}";
/**
 * Metadata for all the requests in the request builder.
 */
export const ExistsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ExistsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createExistsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
